import React, { useState } from "react";
import './register.css';
import Coming from "../coming";

function Registration() {

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        affiliation: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        type: '',
        attachment: null,
        studentId: null,
        paper: ''
    });
    const handleChange = (e) => {
        const { name, value, files } = e.target;
        setFormData({
            ...formData,
            [name]: files ? files[0] : value,
        });
    };
    const handleSubmit = (e) => {
        e.preventDefault();
    
        const templateId = 'your_template_id';
        const userId = 'your_user_id';

        console.log(formData);
    
        // emailjs.sendForm('service_your_service_id', templateId, formData, userId)
        // .then((result) => {
        //     console.log('Email sent successfully!', result.text);
        //     setFormData({
        //         name: '',
        //         email: '',
        //         phone: '',
        //         affiliation: '',
        //         address: '',
        //         city: '',
        //         state: '',
        //         zip: '',
        //         country: '',
        //         type: '',
        //         attachment: null,
        //         studentId: null,
        //         paper: ''
        //     });
        // })
        // .catch((error) => {
        //     console.error('Error sending email:', error);
        // });
    };

    return (
        <div className="abstract">
            <div style={{display: 'flex', columnGap: '5vmax', paddingBottom: '3vmax'}}>
                <div>
                    <h2 className="teamTitle" style={{fontWeight: 700}}>WHEN</h2>
                    <h3 className="reg_des">December 18th - 20th, 2023</h3>
                </div>
                <div>
                    <h2 className="teamTitle" style={{fontWeight: 700}}>WHERE</h2>
                    <h3 className="reg_des">Indian Institute of Technology, Roorkee</h3>
                </div>
            </div>
            <h2 className="teamTitle" style={{fontWeight: 700}}>The registration portal is CLOSED.</h2>
            {/* <div className="reg_des" style={{textAlign: 'left'}}>
                <span className="teamTitle" style={{fontWeight: 700}}>IMPORTANT:</span> Before you complete the following booking details, please make the payment of the registration fee to the following account. The registration fees are listed below:
                <br/><br/>
                <div>
                    <table cellspacing="0" style={{fontSize: '3.6vmax'}}>
                        <tr style={{background: '#D1D5DB'}}>
                            <th colSpan={2}>Fee (without tax)</th>
                            <th>Student/ Research Scholar</th>
                            <th>Faculty Members/ Industry Participants</th>
                        </tr>
                        <tr>
                            <td rowSpan={2}>Foreign Participants</td>
                            <td>
                                Before&nbsp;
                                <del style={{fontSize: '1.3vmax', textDecorationColor: 'red'}}>
                                    31 Oct 2023    
                                </del>
                                &nbsp;15 Nov 2023
                            </td>
                            <td>150 USD</td>
                            <td>450 USD</td>
                        </tr>
                        <tr>
                            <td>
                                After&nbsp;
                                <del style={{fontSize: '1.3vmax', textDecorationColor: 'red'}}>
                                    31 Oct 2023    
                                </del>
                                &nbsp;15 Nov 2023
                            </td>
                            <td>200 USD</td>
                            <td>500 USD</td>
                        </tr>
                        <tr style={{background: '#D1D5DB'}}>
                            <td rowSpan={2}>Indian Participants</td>
                            <td>
                                Before&nbsp;
                                <del style={{fontSize: '1.3vmax', textDecorationColor: 'red'}}>
                                    31 Oct 2023    
                                </del>
                                &nbsp;15 Nov 2023
                            </td>
                            <td>2000 INR</td>
                            <td>5500 INR</td>
                        </tr>
                        <tr style={{background: '#D1D5DB'}}>
                            <td>
                                After&nbsp;
                                <del style={{fontSize: '1.3vmax', textDecorationColor: 'red'}}>
                                    31 Oct 2023    
                                </del>
                                &nbsp;15 Nov 2023
                            </td>
                            <td>3000 INR</td>
                            <td>6500 INR</td>
                        </tr>
                    </table>
                </div>
                <br/>
                <div style={{display: 'flex', justifyContent: 'center'}}>
                    <table cellspacing='0' className="bank_details" style={{fontSize: '3.2vmax'}}>
                        <tr style={{background: '#D1D5DB'}}>
                            <th colSpan={2}>Bank Details</th>
                        </tr>
                        <tr>
                            <td>Bank Name</td>
                            <td style={{paddingLeft: '5vmax', fontWeight: 600}}>STATE BANK OF INDIA</td>
                        </tr>
                        <tr>
                            <td>Branch Office</td>
                            <td style={{paddingLeft: '5vmax', fontWeight: 600}}>IIT ROORKEE- 247667</td>
                        </tr>
                        <tr>
                            <td>Account Name</td>
                            <td style={{paddingLeft: '5vmax', fontWeight: 600}}>VETOMAC 2023 Conference, IIT ROORKEE</td>
                        </tr>
                        <tr>
                            <td>Account Number</td>
                            <td style={{paddingLeft: '5vmax', fontWeight: 600}}>33136732957</td>
                        </tr>
                        <tr>
                            <td>Branch Number</td>
                            <td style={{paddingLeft: '5vmax', fontWeight: 600}}>1069</td>
                        </tr>
                        <tr>
                            <td>IFS Code</td>
                            <td style={{paddingLeft: '5vmax', fontWeight: 600}}>SBIN0001069</td>
                        </tr>
                        <tr>
                            <td>MICR Code</td>
                            <td style={{paddingLeft: '5vmax', fontWeight: 600}}>247002094</td>
                        </tr>
                        <tr>
                            <td>SWIFT Code</td>
                            <td style={{paddingLeft: '5vmax', fontWeight: 600}}>SBININBB559</td>
                        </tr>
                        <tr>
                            <td>PAN Number</td>
                            <td style={{paddingLeft: '5vmax', fontWeight: 600}}>AAALI0033R</td>
                        </tr>
                        <tr>
                            <td>GST Number</td>
                            <td style={{paddingLeft: '5vmax', fontWeight: 600}}>05AALI0033R1Z5</td>
                        </tr>
                        <tr>
                            <td>Account Type</td>
                            <td style={{paddingLeft: '5vmax', fontWeight: 600}}>SAVING</td>
                        </tr>
                    </table>
                </div>
                <br/>
                <span className="teamTitle" style={{fontWeight: 700}}>NOTE:</span> For all student participants, you must attach a copy of your valid student ID issued by your institution for your registration to be approved. Registration for Indian students is currently applicable only for student authors/ presenters of accepted full papers. Contact vetomac2023@iitr.ac.in for general student registrations.
            </div>
            <br/><br/><br/>
            <div style={{textAlign: 'left', paddingBottom: '2vmax'}}>
                <h2 className="teamTitle" style={{fontWeight: 700}}>Steps to follow while registering:</h2>
                <p className="reg_des">1. We encourage you to use your institutional email ID to register.</p>
                <p className="reg_des">2. Please enter your personal details carefully as it will be used to validate your registration based on the receipt of payment.</p>
                <p className="reg_des">3. Please select your VETOMAC 2023 registration type from the list below. Only one registration is allowed at a time.</p>
                <p className="reg_des">4. This system does not allow direct payment, hence please make the payment beforehand and attach the receipt below.</p>
                <p className="reg_des">5. If you are an author or a presenter, please mention your paper number.</p>
            </div> */}
            <p className="reg_des">Please email <i style={{fontSize: '1.4vmax'}}>vetomac2023@iitr.ac.in</i> if you have any queries or require assistance regarding the registration process.</p>
            <div style={{paddingBottom: '4vmax'}}></div>
            <div>
                {/* <h2 className="compTitle" style={{paddingBottom: '1vmax'}}>Registration Form</h2> */}
                {/* <form onSubmit={handleSubmit} style={{textAlign: 'left'}}>
                    <div style={{display: 'flex', gap: '4vmax'}}>
                        <div style={{display: 'flex', justifyContent: 'space-between', width: '35vmax', alignItems: 'center'}}>
                            <label>Name<span style={{color: 'red', fontSize: '1.4vmax', textTransform: 'uppercase'}}>*</span></label>
                            <input
                                placeholder="Eg. John Doe"
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div style={{display: 'flex', justifyContent: 'space-between', width: '35vmax', alignItems: 'center'}}>
                            <label>Email<span style={{color: 'red', fontSize: '1.4vmax', textTransform: 'uppercase'}}>*</span></label>
                            <input
                                placeholder="Eg. john@doe.com"
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>
                    <div style={{display: 'flex', gap: '4vmax'}}>
                        <div style={{display: 'flex', justifyContent: 'space-between', width: '35vmax', alignItems: 'center'}}>
                            <label>Phone<span style={{color: 'red', fontSize: '1.4vmax', textTransform: 'uppercase'}}>*</span></label>
                            <input
                                placeholder="Eg. +91 99999 00000"
                                type="tel"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div style={{display: 'flex', justifyContent: 'space-between', width: '35vmax', alignItems: 'center'}}>
                            <label>Affiliation<span style={{color: 'red', fontSize: '1.4vmax', textTransform: 'uppercase'}}>*</span></label>
                            <input
                                type="text"
                                name="affiliation"
                                value={formData.affiliation}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>
                    <div style={{display: 'flex', gap: '2vmax', alignItems: 'center'}}>
                        <label>Address<span style={{color: 'red', fontSize: '1.4vmax', textTransform: 'uppercase'}}>*</span></label>
                        <input
                            style={{width: '85%'}}
                            type="text"
                            name="address"
                            value={formData.address}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div style={{display: 'flex', gap: '4vmax'}}>
                        <div style={{display: 'flex', justifyContent: 'space-between', width: '35vmax', alignItems: 'center'}}>
                            <label>City<span style={{color: 'red', fontSize: '1.4vmax', textTransform: 'uppercase'}}>*</span></label>
                            <input
                                type="text"
                                name="city"
                                value={formData.city}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div style={{display: 'flex', justifyContent: 'space-between', width: '35vmax', alignItems: 'center'}}>
                            <label>State/Province<span style={{color: 'red', fontSize: '1.4vmax', textTransform: 'uppercase'}}>*</span></label>
                            <input
                                type="text"
                                name="state"
                                value={formData.state}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>
                    <div style={{display: 'flex', gap: '4vmax'}}>
                        <div style={{display: 'flex', justifyContent: 'space-between', width: '35vmax', alignItems: 'center'}}>
                            <label>Zip/Postal Code<span style={{color: 'red', fontSize: '1.4vmax', textTransform: 'uppercase'}}>*</span></label>
                            <input
                                type="text"
                                name="zip"
                                value={formData.zip}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div style={{display: 'flex', justifyContent: 'space-between', width: '35vmax', alignItems: 'center'}}>
                            <label>Country<span style={{color: 'red', fontSize: '1.4vmax', textTransform: 'uppercase'}}>*</span></label>
                            <input
                                type="text"
                                name="country"
                                value={formData.country}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>
                    <div>
                        <label>Registration Type<span style={{color: 'red', fontSize: '1.4vmax', textTransform: 'uppercase'}}>*</span></label>
                        <select
                            name="type"
                            value={formData.type}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Select Registration Type</option>
                            <option value="Student Participant - Indian">Student Participant - Indian</option>
                            <option value="Student Participant - Foreign">Student Participant - Foreign</option>
                            <option value="General Participant - Indian">General Participant - Indian</option>
                            <option value="General Participant - Foreign">General Participant - Foreign</option>
                        </select>
                    </div>
                    <div style={{display: 'flex', gap: '2vmax', alignItems: 'center'}}>
                        <label>Upload the receipt of registration fee payment<span style={{color: 'red', fontSize: '1.4vmax', textTransform: 'uppercase'}}>*</span></label>
                        <input
                            type="file"
                            name="attachment"
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div style={{display: 'flex', gap: '2vmax', alignItems: 'center'}}>
                        <label>Upload a valid student ID [for student participants only]: </label>
                        <input
                            type="file"
                            name="studentId"
                            onChange={handleChange}
                        />
                    </div>
                    <div style={{display: 'flex', gap: '2vmax', alignItems: 'center'}}>
                        <label>Paper Number: </label>
                        <input
                            placeholder="Eg. 000"
                            type="text"
                            name="paper"
                            value={formData.paper}
                            onChange={handleChange}
                        />
                    </div>
                    <br/><br/>
                    
                </form> */}
                {/* <br/><br/><br/>
                <a href="https://forms.gle/JcHNU3hHZ5oVhxSQ7" target="_blank" style={{all: 'unset'}}>
                    <button className='submitBtn' type="submit">Link to registration form</button>
                </a> */}
                <br/><br/><br/>
                <a href="https://docs.google.com/spreadsheets/d/1fQgLqXppNpjNATbMjSdC4CqcwzCOQOt_uIsy5ffgieI/edit?usp=sharing" target="_blank" style={{all: 'unset'}}>
                    <button className='submitBtn' type="submit">Link to fill accomodation preference</button>
                </a>
            </div>
        </div>
    )
}

export default Registration;